/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * SIN-PROD environment settings
 *
 * @file sinprod.js
 * @author JP
 * @since 1.0.0
 */

import base from './base';

const sinprod = {
  GLS_APP_ID: '59a94f689128d549d18522ad',
  GLS_API_BASE_URL: 'https://api-sin-prod.gls.pearson-intl.com/product'
};

export default {
  ...base,
  ...sinprod
};
